import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FiUsers, FiServer, FiDollarSign, FiActivity } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { admin } from '../../components/admin/adminUi';
import priceBG from '../../assets/images/price-bg.png';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalServers: 0,
    totalTransactions: 0,
    totalRevenue: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data.stats);
    } catch (error) {
      toast.error('Failed to fetch stats');
    } finally {
      setLoading(false);
    }
  };

  const statBlocks = [
    {
      label: 'Total Users',
      value: stats.totalUsers,
      icon: FiUsers,
      tone: 'blue',
      href: '/admin/users',
      link: 'View all users'
    },
    {
      label: 'Total Servers',
      value: stats.totalServers,
      icon: FiServer,
      tone: 'green',
      href: '/admin/servers',
      link: 'View all servers'
    },
    {
      label: 'Transactions',
      value: stats.totalTransactions,
      icon: FiActivity,
      tone: 'violet',
      href: '/admin/transactions',
      link: 'View transactions'
    },
    {
      label: 'Total Revenue',
      value: `€${stats.totalRevenue.toFixed(2)}`,
      icon: FiDollarSign,
      tone: 'amber',
      href: null,
      link: null
    }
  ];

  return (
    <Layout>
      <div className={admin.page}>
        <div>
          <h1 className={admin.title}>Admin</h1>
          <p className={admin.subtitle}>Overview and quick actions for your platform.</p>
        </div>

        {loading ? (
          <div className={`${admin.card} ${admin.cardInner} text-[#BABABA]`}>Loading statistics…</div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
            {statBlocks.map(({ label, value, icon: Icon, tone, href, link }) => (
              <div
                key={label}
                className={admin.statCard}
                style={{ backgroundImage: `url(${priceBG})` }}
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-sm text-[#BABABA]">{label}</p>
                    <p className="mt-2 text-3xl font-semibold text-white tabular-nums">{value}</p>
                    {href && link ? (
                      <Link to={href} className={`${admin.link} mt-3 inline-block`}>
                        {link} →
                      </Link>
                    ) : null}
                  </div>
                  <div
                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${admin.iconBox(
                      tone
                    )}`}
                  >
                    <Icon size={22} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className={admin.card}>
          <div className={`border-b border-[#FFFFFF10] px-5 py-4`}>
            <h2 className="text-lg font-semibold text-white">Quick actions</h2>
            <p className="text-sm text-[#BABABA]">Jump to management sections</p>
          </div>
          <div className="grid gap-3 p-5 sm:grid-cols-3">
            <Link to="/admin/users" className={admin.quickAction}>
              <FiUsers className="text-[#8BA3FF]" size={22} />
              <span className="font-medium text-white">Users</span>
              <span className="text-xs text-[#BABABA]">Balances, passwords, roles</span>
            </Link>
            <Link to="/admin/servers" className={admin.quickAction}>
              <FiServer className="text-[#4ADE80]" size={22} />
              <span className="font-medium text-white">Servers</span>
              <span className="text-xs text-[#BABABA]">All customer RDP instances</span>
            </Link>
            <Link to="/admin/transactions" className={admin.quickAction}>
              <FiActivity className="text-[#C4B5FD]" size={22} />
              <span className="font-medium text-white">Transactions</span>
              <span className="text-xs text-[#BABABA]">Payments and adjustments</span>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdminDashboard;
